export const defaultVykazyChanges = {
  subtask: {
    ADD: [],
    EDIT: [],
    DELETE: []
  },
  trip: {
    ADD: [],
    EDIT: [],
    DELETE: []
  },
  material: {
    ADD: [],
    EDIT: [],
    DELETE: []
  },
}
/*
export const noTaskType = {
  label: 'No task type',
  labelId: 'noTaskType',
  id: null,
  value: null,
}
*/
